import { useMutation } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import {
  DocumentDataExclusionReasons,
  DocumentDataStatusFilters,
} from '../../../types/packager-types';

type IUseDocumentDataCreateProps = {
  document: string;
  status?: DocumentDataStatusFilters;
  exclusionReason?: DocumentDataExclusionReasons;
  escalationDetail?: string;
};

export const useDocumentDataCreate = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: IUseDocumentDataCreateProps) => {
      return await (await glynt).documentData.create(data);
    },

    ...callbacks
  });
};
